import apiFetch from '../apiFetch'

export default function (token) {
  return apiFetch({ endPoint: 'MassiveDownloadStatus/All', method: 'GET', body: null, token: token })
}
